export default "__VITE_ASSET__p4MgYKSk__"